<template>
  <div v-cloak v-if="diskUsage !== null" class="box">
    <div class="w-full h-2 relative">
      <div class="absolute w-full h-full">
        <span
          class="bg-[#f2f2f2] absolute right-0 top-0"
          :style="('width:' + (100 - percentage) + '%')"
        />
        <span
          class="bg-[#827bff] w-3/5"
        />
        <span
          class="bg-[#ffd165]"
          style="width: 30%;"
        />
        <span
          class="bg-[#ef5454]"
          style="width: 10%;"
        />
      </div>
    </div>
    <div class="mt-2">
      <i class="fa-regular fa-hard-drive mr-2" />
      {{ diskUsageGB }} GB of {{ totalSpaceGB }} GB used.
    </div>
    <button
      v-if="!hasTeam && !hasAnnualPlan"
      class="mt-3 text-primary-green text-xs font-bold uppercase inline-block"

      @click="clickOnUpgrade"
    >
      Upgrade
    </button>
  </div>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import apiClient from '@/utilities/api-client';
import getContext from '@/utilities/get-context';

export default {
  data() {
    return {
      kbInGb: 1048576,
      diskUsage: null,
      availableSpace: null,
    };
  },
  computed: {
    diskUsageGB() {
      if (this.availableSpace === -1) {
        return 0;
      }

      const diskUsageGB = (this.diskUsage / this.kbInGb);

      let digits = 2;
      if (diskUsageGB < 0.1 && diskUsageGB > 0) {
        digits = 3;
      }

      return diskUsageGB.toFixed(digits);
    },

    totalSpaceGB() {
      if (this.availableSpace === -1) {
        return 'Unlimited';
      }

      return (this.totalSpace / this.kbInGb).toFixed(2);
    },

    totalSpace() {
      return this.availableSpace + this.diskUsage;
    },

    percentage() {
      return ((this.diskUsage * 100) / this.totalSpace).toFixed(2);
    },

    hasTeam() {
      return getContext().__MA__.user.hasTeam;
    },

    hasAnnualPlan() {
      return getContext().__MA__.user.plan.includes('yearly');
    }
  },
  async mounted() {
    const { data } = await apiClient.get('/api/me/accounts/menu-conditions');
    this.diskUsage = data.disk_usage;
    this.availableSpace = data.available_space;
  },

  methods: {
    clickOnUpgrade() {
      eventTracker(analyticsEvents.clickOnGetALicense, {
        source: 'my account menu',
        button_name: 'upgrade',
      });
      window.location.replace('/pricing/');
    },
  },
};
</script>

<style scoped>
.bg-\[\#f2f2f2\] {
    background-color: #f2f2f2;
}
.bg-\[\#827bff\] {
    background-color: #827bff;
}
.bg-\[\#ffd165\] {
    background-color: #ffd165;
}
.bg-\[\#ef5454\] {
    background-color: #ef5454;
}
.text-\[\#b2b2b2\] {
    color: #b2b2b2;
}
.text-\[\#827bff\] {
    color: #827bff;
}
.box {
    @apply p-5 text-[#b2b2b2];
    border: 1px solid #e6e6e6;
    border-radius: 10px;
}
span {
    @apply inline-block h-2 float-left;
    border-radius: 10px;
}
</style>
